import Button from "ui/eds/Button";
import styled from "styled-components/macro";
import { theme } from "ui/theme";
import { ReactComponent as GetHelpSVG } from "images/get_help.svg";
import { useGetHelpContext } from "components/GetHelpModal/GetHelpContext";
import { transition } from "helpers/css";

const $ButtonContainer = styled.div`
  width: 3rem;
  height: 4.5rem;
  position: fixed;
  right: 1.7rem;
  bottom: 1.7rem;
  z-index: ${theme.zIndexLevelThree};
`;

const $Button = styled(Button)`
  border: 0;
  padding: 0;
  width: 3rem;
  height: 3rem;

  border-radius: 50%;
  overflow: clip;

  box-shadow: ${({ theme }) => theme.BoxShadowAlongSpace};

  &:hover {
    svg circle {
      ${transition("fill 0.2s ease-in")}
      fill: ${theme.ColorBlurple400};
    }
  }
`;

export default function GetHelpButton() {
  const { getHelp } = useGetHelpContext();

  return (
    <$ButtonContainer>
      <$Button
        aria-label="Get Help"
        analyticsName="opened_get_help_modal"
        onClick={() => getHelp()}
      >
        <GetHelpSVG />
      </$Button>
    </$ButtonContainer>
  );
}
